import { Facebook, Instagram, Youtube } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useSite } from "@/context/SiteContext";
import TikTokIcon from "./TikTokIcon";

const SOCIALS = [
  { key: "social_facebook", label: "FACEBOOK", icon: Facebook, testid: "social-facebook" },
  { key: "social_instagram", label: "INSTAGRAM", icon: Instagram, testid: "social-instagram" },
  { key: "social_tiktok", label: "TIKTOK", icon: TikTokIcon, testid: "social-tiktok" },
  { key: "social_youtube", label: "YOUTUBE", icon: Youtube, testid: "social-youtube" },
];

export default function SocialBand({ title = "Vezi ce construim acum", copy }) {
  const { config } = useSite();
  const active = SOCIALS.filter((s) => (config[s.key] || "").trim());
  const text = copy || "Publicăm constant imagini din timpul lucrărilor, proiecte finalizate și proiecte noi. Urmărește Brox Construct pe social media pentru cele mai recente lucrări.";

  return (
    <section className="border-y border-white/10 bg-ink-900 py-14 sm:py-20" data-testid="social-section">
      <div className="container-brox text-center">
        <Reveal>
          <h2 className="display-title text-3xl sm:text-5xl" data-testid="social-title">{title}</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-muted-foreground sm:text-base" data-testid="social-copy">
            {text}
          </p>
        </Reveal>
        {active.length > 0 && (
          <Reveal delay={0.18}>
            <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
              {active.map(({ key, label, icon: Icon, testid }) => (
                <a
                  key={key}
                  href={config[key]}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex min-h-[52px] items-center gap-2.5 border border-white/15 bg-ink-950 px-6 font-display text-base font-bold uppercase tracking-wider text-paper transition-all duration-300 hover:border-copper hover:text-copper"
                  data-testid={testid}
                >
                  <Icon className="h-5 w-5" />
                  {label}
                </a>
              ))}
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}
